import { RestResponse } from "@/business/shared/commons/rest/RestResponse";
import { restClient } from "@/business/shared/commons/rest/restClient";
import { errorManagerActions } from "@/business/shared/commons/rest/errorManagerActions";
import { getEnvVariable } from "@/business/shared/commons/envUtils/getEnvVariable";
import { Client, ClientActions } from "../../domain/clients";
import { getClientById } from "../constants/urls";

export const getClientByIdService = {
  async execute(id: string): Promise<Client> {
    const url = getEnvVariable
      .execute("VUE_APP_SUBSCRIPTION_UB_URL")
      .concat(getClientById)
      .replace("{clientId}", id);

    const response: RestResponse = await restClient().sendRequest(url, "GET");

    // if (!response.isSuccess) {
    //   throw errorManagerActions().transformBC(response.content);
    // }

    return ClientActions().deserializeObject(response.content);
  },
};
